import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/shared/lib/cn";

/** A quiet shortcut hint; group a chord with KbdGroup to share one surface. */
export interface KbdProps {
  children: ReactNode;
  className?: string;
}

export function Kbd({ children, className }: KbdProps) {
  return (
    <kbd className={cn("studio-kbd", className)}>
      {children}
    </kbd>
  );
}

export function KbdGroup({ className, ...props }: HTMLAttributes<HTMLSpanElement>) {
  return <span {...props} className={cn("studio-kbd-group", className)} />;
}
